import { ENV } from "../utils";

export class EnvironmentalRiskMatrixIso14091form {
  baseApi = ENV.BASE_API;

  async getEnvironmentalRiskMatrixIso14091(accessToken, id) {
    try {
      const url = `${this.baseApi}/environmentalriskmatrix-iso14091/${id}`;
      const params = { headers: { Authorization: `Bearer ${accessToken}` } };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async createEnvironmentalRiskMatrixIso14091(accessToken, data) {
    try {
      const url = `${this.baseApi}/add-environmentalriskmatrix-iso14091`;
      const params = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateEnvironmentalRiskMatrixIso14091(accessToken, id, data) {
    try {
      const url = `${this.baseApi}/environmentalriskmatrix-iso14091/${id}`;
      const params = {
        method: "PUT",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteEnvironmentalRiskMatrixIso14091(accessToken, id) {
    try {
      const url = `${this.baseApi}/delete-environmentalriskmatrix-iso14091/${id}`;
      const params = { method: "DELETE", headers: { Authorization: `Bearer ${accessToken}` } };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getEnvironmentalRiskMatricesIso14091BySite(accessToken, site) {
    try {
      const url = `${this.baseApi}/environmentalriskmatrix-iso14091-site/${site}`;
      const params = { headers: { Authorization: `Bearer ${accessToken}` } };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
}
